// Module
var code = "<p>EMPTY</p> ";
// Exports
module.exports = code;